<ul
  aria-label="Main navigation menu"
  class="px-2"
  nz-menu
  nzMode="inline"
  nzTheme="light"
  role="navigation"
  [nzInlineCollapsed]="collapsed()"
>
  @for (menu of visibleMenus(); track menu.id) {
    <li nz-menu-group [nzTitle]="collapsed() ? '' : (menu.header | translate)">
      <ul>
        @for (item of menu.items; track item.link) {
          <li
            nz-menu-item
            nz-tooltip
            nzMatchRouter
            [class.active]="item.isActive"
            [nzTooltipPlacement]="'right'"
            [nzTooltipTitle]="(collapsed() ? item.title : '') | translate: { defaultText: item.title }"
            [routerLink]="item.link"
          >
            <i nz-icon style="color: gray" [nzTheme]="item?.nzTheme" [nzType]="item.iconSrc"></i>
            @if (!collapsed()) {
              <span>{{ item.title | translate: { defaultText: item.title } }}</span>
            }
          </li>
        }
      </ul>
    </li>
  }
</ul>
